import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

// Gym Member steps
import Create_Account_step1 from "./gym-member/create-account-step-1/Create_Account_step1";
import Create_Account_Step2 from "./gym-member/create-account-step-2/Create_Account_Step2";
import Create_Account_Step3 from "./gym-member/create-account-step-3/Create_Account_Step3";
import Create_Account_Step4 from "./gym-member/create-account-step-4/Create_Account_Step4";
import Create_Account_Step5 from "./gym-member/create-account-step-5/Create_Account_Step5";
import Create_Account_Step6 from "./gym-member/create-account-step-6/Create_Account_Step6";

// Gym Owner steps
import Create_Step1 from "./gym-owner/create-step1/Create_Step1";
import Create_Step2 from "./gym-owner/create-step2/Create_Step2";
import Create_Step3 from "./gym-owner/create-step3/Create_Step3";
import Create_Step4 from "./gym-owner/create-step4/Create_Step4";
import Create_Step5 from "./gym-owner/create-step5/Create_Step5";
import Create_Step6 from "./gym-owner/create-step6/Create_Step6";
import Create_Step7 from "./gym-owner/create-step7/Create_Step7";
import Success_Page from "./gym-member/success-page/Success_Page";
import Owner_Success_Page from "./gym-owner/owner-success-page/Owner_Success_Page";

const Login_Flow = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});  // ← shared across all steps
  console.log(formData);

  const [searchParams] = useSearchParams();
  const role = searchParams.get("role"); // member | owner

  //  SCROLL TO TOP ON STEP CHANGE
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [step]);

  if (role === "member") {
    return (
      <>
        {step === 1 && <Create_Account_step1 setStep={setStep} formData={formData} setFormData={setFormData} />}
        {step === 2 && <Create_Account_Step2 setStep={setStep} formData={formData} setFormData={setFormData} />}
        {step === 3 && <Create_Account_Step3 setStep={setStep} formData={formData} setFormData={setFormData} />}
        {step === 4 && <Create_Account_Step4 setStep={setStep} formData={formData} setFormData={setFormData} />}
        {step === 5 && <Create_Account_Step5 setStep={setStep} formData={formData} setFormData={setFormData} />}
        {step === 6 && <Create_Account_Step6 setStep={setStep} formData={formData} setFormData={setFormData} />}
        {step === 7 && <Success_Page setStep={setStep} />}
      </>
    );
  }

  /* ================= GYM OWNER FLOW ================= */
  if (role === "owner") {
    return (
      <>
        {step === 1 && <Create_Step1 step={1} totalSteps={7} setStep={setStep} />}
        {step === 2 && <Create_Step2 step={2} totalSteps={7} setStep={setStep} />}
        {step === 3 && <Create_Step3 step={3} totalSteps={7} setStep={setStep} />}
        {step === 4 && <Create_Step4 step={4} totalSteps={7} setStep={setStep} />}
        {step === 5 && <Create_Step5 step={5} totalSteps={7} setStep={setStep} />}
        {step === 6 && <Create_Step6 step={6} totalSteps={7} setStep={setStep} />}
        {step === 7 && <Create_Step7 step={7} totalSteps={7} setStep={setStep} />}
        {step === 8 && <Owner_Success_Page setStep={setStep} />}
      </>
    );
  }

  return null;
};

export default Login_Flow;
